module.exports = __webpack_public_path__ + "img/Metronik.42b4982b.png";